const en = {
  home: {
    menuName: 'Home'
  },
  service: {
    menuName: 'Services',
    subMenu1: 'Imaging CRO',
    subMenu2: '3D Post-Processing',
    msg1: 'Extensive Imaging applies image processing and artificial intelligence technologies to imaging medicine, and provides imaging data analysis and diagnostic services closely related to clinical applications for physicians and patients, adhering to internationally recognized 3D imaging clinical diagnostic standards. Additionally, Extensive Imaging offers services such as medical imaging big data transmission, storage, sharing, statistics, and quality control for clients leveraging the advantages of cloud platforms.'
  },
  imagingService: {
    tab1: 'Imaging CRO',
    tab2: 'Criteria',
    tab3: 'Indications',
    tab4: 'Workflow Platform',
    tab5: 'Expertise',
    tab6: 'Imaging System',

    title1: 'Scope',
    title2: 'Services',
    title3: 'Business Workflow',
    title4: 'Key Advantages',
    title5: 'Global Network of Experts',
    title6: 'Operations Team',
    msg1: 'Whether you are pharmaceutical companies, biotech startups, contract research organizations, or biomedical research institutions, Extensive Imaging’s Research can provide you with clinical trial-related medical imaging services.',
    msg2: 'Every clinical trial is unique, facing different requirements and challenges. Extensive Imaging’s Research offers you a series of medical imaging services, which covers from early stage R&D projects to large scale, international multicenter trials.',
    msg3: 'Non-Oncology Imaging Review Criteria',
    msg4: 'Nowadays there are more participants and stakeholders in multi-center clinical trials, and the volume of imaging data involved is increasing rapidly. At the same time, requirements of regulatory compliance have become even more strict. Because of this, Extensive Imaging’s Research developed a cloud-based clinical trial imaging workflow management system which can facilitate communications, reduce response time and guarantee the security and traceability of data.',
    msg5: 'This system covers every step of IRC imaging assessment, from project setup to trial site surveys to image upload to the final data export. All stakeholders can work on a cloud-based, unified system, and keep connected and informed throughout the entire process on a global scale.',
    msg6: '',
    msg7: 'This cloud-based medical image reading software is designed specifically for image-based treatment response assessment in clinical trials.',
    msg7_1: 'With the integrated rules and logic of the latest response criteria, this system can increase the accuracy of lesion measurements, reduce readers’ subjectivity and errors, ensure data quality and traceability, and improve the overall reading efficiency.',
    msg7_2: 'In addition to major response criteria, such as RECIST1.1, PCWG3, Lugano 2014, iRECIST, etc., this system also supports customized or self-defined criteria through its highly flexible configuration tools.',
    msg7_3: 'This system also provides readers with a set of advanced medical image reading tools, including Layout, Windowing, Inverse Color, Move, Rotate, Fit to Image, Screenshot, Diameter Measurement, Bidirectional Measurement, Arrow etc. DICOM images can be displayed based on subjects, visits, studies, or series, and non-DICOM images are also supported.',
    msg8: 'Flexible Deployment: Cloud or on-premise, to secure, compliant, and user-friendly.',
    msg9: 'Automated Reporting: Measurement results auto-populate into standardized eCRFs for accuracy and reliability.',
    msg10: 'Versatile Tools: Multiple lesion measurement options for readers.',
    msg11: 'Broad Compatibility: Support standard DICOM data, non-standard images and clinical data.',
    msg12: 'Regulatory Compliance: Meets NMPA, FDA 510(k), CE, 21 CFR Part 11, Gxp, HIPPA.',
    msg13: 'Extensive Imaging’s advantages in clinical trial imaging services are inseparable from our operations team with rich industry experience and rigorous work attitude, as well as the comprehensive professional knowledge support of our internal and external experts.',
    msg14: 'Chinese and foreign expert team covers imaging, oncology, orthopedics, hematology, ENT and other specialties.',
    msg15: 'Senior overseas experts work in prestigious institutions such as Massachusetts General Hospital, Dana-Farber, Sloan Kettering, etc., and many have participated in more than 500 trials.',
    msg16: 'Chinese experts come from large tertiary hospitals in Beijing & Shanghai, and have rich hands-on experience in imaging trials.',
    msg17: 'Advisory committee members include experts at the president and vice-president level from ACR, RSNA, and Chinese Society of Radiology.',
    msg18: 'Harvard Medical School-certified program for independent central review (since 2017).',
    msg19: 'Project managers team has combined experience of more than 100 trials.',
    msg20: 'Medical & scientific team is composed of senior physicians with imaging and clinical backgrounds from China and the United States, and many of them have worked in the top 10 hospitals in both countries.',
    msg21: 'All quality control personnel have clinical or imaging background.',
    msg22: 'R&D personnel have many years of experience in healthcare IT and imaging technology industry.'
  },
  processingService: {
    tab1: '3D Post-Processing',
    tab2: 'Services',
    tab3: 'Workflow',
    tab4: 'Cases',
    tab5: '3D Reconstructions',
    tab6: 'Image-Based Surgical Planning',
    title1: '3D Post-Processing',
    title2: 'Benefits to Clients',
    title3: 'Regulatory Compliance',
    title4: 'Cardiovascular',
    title5: 'Neurological',
    title6: 'Thoracic',
    title7: 'Abdominal',
    title8: 'Musculoskeletal',
    title9: 'Liver Mass',
    title10: 'Femoral Shaft Fracture',
    title11: 'Transcatheter Aortic Valve Implantation (TAVI)',
    title12: 'Kidney Mass',
    title13: 'Pancreatic Tumor',
    title14: 'Abdominal Aortic Aneurysm (AAA)',
    msg1: `Advanced 3D post-processing of CT and MRI images has become indispensable to clinical practice.
          However,
          hospitals face enormous challenges to implement high-quality, cost-effective 3D post-processing
          solutions
          which can meet the ever-growing clinical demand. Everest Digital Medicine is an independent
          post-processing center with specially trained radiologists and technologists, state-of-the-art
          workstations, and validated clinical 3D protocols. We work with our clients to integrate advanced
          medical
          imaging technologies into their patient care.`,
    msg2: 'Low cost, scalable turn-key 3D solution',
    msg3: '24/7 availability & short turn-around time',
    msg4: 'Specialized workforce & high post-processing quality',
    msg5: 'Client\'s technologists can focus on CT/MRI scans',
    msg6: 'Expand into sub-specialty reading services',
    msg7: `Data transmission on our HIPPA-compliant network is encrypted with sophisticated algorithms. Image data
          is anonymized prior to transmission from the hospital, then stored at our data center with 24/7 security
          and back-up. Our radiologists process the images without knowledge of patients' identities.`,
    msg8: `Everest Digital Medicine offers a wide range of 3D Post-Processings for CT and MRI studies.
          These services encompass reconstructions, quantitative analysis, and image-based surgical planning.`,
    msg9: `Our radiologists and imaging specialists work with clients to design customized protocols based on their
          clinical requirements.`,
    msg10: 'The following two tables are a list of protocols of 3D reconstruction, and image-based surgical planning.',
    msg11: 'Image data is anonymized and sent to our 3D lab via HIPPA compliant VPN network.',
    msg12: 'Our radiologists process 2D images on FDA-cleared 3D workstations.',
    msg13: 'Resulting 3D images are sent back to clients\' PACS for physician reading',
    msg14: 'Please click to enlarge!',
    table_Reconstructions: {
      th1: 'Body Systems',
      th2: '3D Post-Processing Protocols',
      td1: 'Cardiovascular',
      td2: 'Cardiac CTA, aorta CTA, coronary artery analysis,pulmonary CTA, CT venogram, coronary score, ejection fraction, & measurements for stenting',
      td3: 'Neurological',
      td4: 'Head CTA, head CT venogram, & neck CTA',
      td5: 'Thoracic',
      td6: 'Chest/trachea VR, pulmometry, & tumor pre-surgical',
      td7: 'Abdominal',
      td8: 'Liver CTA, pancreatic CTA, mesenteric CTA, renal CTA, pelvic CTA, abdominal VR, & virtual endoscopy',
      td9: 'Musculoskeletal',
      td10: `Bone CT/CTA, VR & joint view for facial fracture, collum femoris fracture,
            thoracic fracture, shoulder fracture, pelvic fracture, limb fracture, bone implant VR, &
            TT-GT measurement`
    },
    table_ImageBased: {
      th1: 'Subspecialties',
      th2: 'Protocols',
      td1: 'Cardiovascular',
      td2: 'Coronary disease intervention, aortic and dissecting aneurysms interventional, TAVI, & left atrial appendage closure(LAAC)',
      td3: 'Head and Neck',
      td4: 'Intracranial angioma, & carotid artery stenosis disease interventional therapy',
      td5: 'Thoracic',
      td6: 'Lung nodule follow-up, lung and mediastinum tumors pre-surgical, & emphysema treatment',
      td7: 'Abdominal',
      td8: 'Hepatic tumor, gastric tumor, pancreatic tumor, renal tumor, adrenal tumor, renal transplant, & renal calculus pre-surgical',
      td9: 'Oskeletal',
      td10: 'Fractures VR & measurement',
      td11: 'Pediatric surgical',
      td12: 'Congenital abnormalities of the urinary system, digestive tract and skeletal bone,& congenital heart disease'
    }
  },
  ImageBasedSurgicalPlanning: {
    tab_LM: 'Liver Mass',
    tab_FSF: 'Femoral Shaft Fracture',
    tab_TAVI: 'TAVI',
    tab_KM: 'Kidney Mass',
    tab_PT: 'Pancreatic Tumor',
    tab_AAA: 'AAA',
    title1: 'Series',
    title2: 'Clinical Implications',
    title3: 'Images',
    title4: 'Liver Mass',
    title5: 'Cases: ',
    title6: 'Image-Based Surgical Planning',
    msg1: 'Please click each thumbnail to see the complete image series.',
    LM: {
      series_LM1: 'Abd Aorta MIP',
      clinical_LM1: 'Showing origins, courses &amp; shapes of abdominal aorta and its major branches.',
      series_LM2: 'Abd Aorta VR',
      clinical_LM2: 'External view of origins, courses &amp; shapes of abdominal aorta and its major branches.',
      series_LM3: 'ALiver Mass &amp; Abd Aorta VR',
      clinical_LM3: 'VR images of liver mass, abdominal aorta and its major branches, showing the relationship between the mass and neighboring vessels.',
      series_LM4: 'Liver Mass &amp; Abd Aorta Bone VR',
      clinical_LM4: 'VR images of stained liver mass, abdominal aorta and its major braches are overlapped with the abdominal image: showing the relationship among the mass, abdominal aorta, its major branches, neighboring bones and organs.',
      series_LM5: 'Abd Aorta &amp; Major Branches MIP',
      clinical_LM5: 'Oblique MIP of abdominal aorta and its major branches<br> Common Hepatic Artery<br> Superior Mesenteric Artery<br> Lt Renal Artery<br> Rt Renal Artery',
      series_LM6: 'Mass Measurements',
      clinical_LM6: 'Mass measurements on multiple planes:<br> Axial Dmax = 102.9 mm<br> Coronal Dmax = 100.2 mm<br> Sagittal Dmax = 80.8 mm<br> Volume：267.467 cm³',
      series_LM7: 'Mass to neighboring arteries distances',
      clinical_LM7: 'Distances to neighboring abdominal vessels <br> To Right Hepatic Artery: 9.5 mm<br> To Common Hepatic Artery: 58.7 mm<br> To Celiac Artery: 45.4 mm<br> To Right Renal Artery: 26.8 mm<br> To Cystic Artery: 85.6 mm<br> To Splenic Artery: 72.2 mm<br> To SMA: 58.6 mm',
      series_LM8: 'Mass to neighboring bones/organs distances',
      clinical_LM8: 'Distances to neighboring bones &amp; organs<br> To Right Kidney: 1.0 mm<br> To Ribs：0 mm<br> To Lumbar Vertebrae：1.5 mm<br> To Skin：89.9 mm<br> To Lesser Curvature of Stomach：58.9 mm'
    },
    FSF: {
      series_FSF1: 'VR with overlying hip joint',
      clinical_FSF1: 'Compare fractured femur with the contralateral, showing fracture displacement and bone fragment avulsion.',
      series_FSF2: 'VR without overlying hip joint',
      clinical_FSF2: 'Showing fracture site, fracture displacement and bone fragment avulsion.',
      series_FSF3: 'Bone MIP',
      clinical_FSF3: 'Showing displaced fracture and complete fracture.',
      series_FSF4: 'Bone MPR',
      clinical_FSF4: 'Showing fracture line and fracture site, showing the relationship between fracture &amp; its neighboring structures.',
      series_FSF5: 'Measurements',
      clinical_FSF5: 'Measure fracture length, assess method of fracture reduction, help to decide the right size of the internal plate, and the location , angle and distance of screw placement.'
    },
    TAVI: {
      series_TAVI1: 'Aorta Root Measurements',
      clinical_TAVI1: 'Showing number of aortic valve leaflets, extent of calcification of leaflets, distances from aortic annular plane to the lower point of the left and right coronary ostium <br> 1. Diameters of LVOT: Dmax = 34.3 mm Dmin = 19.8 mm<br> 2. Diameter of coronary sinus: Dmax = 40.9 mm <br> 3. Diameter of sinotubular junction: Dmax = 30.0 mm <br> 4. Distance from right ostium to annulus: 18.3 mm<br> &nbsp;&nbsp;&nbsp;&nbsp;Distance from left ostium to annulus: 17.6 mm',
      series_TAVI2: 'Annulus Dimensions',
      clinical_TAVI2: 'Measure diameters, area of annulus, showing its shape<br> 1. Diameters: Dmax = 30.2 mm <br> &nbsp;&nbsp;&nbsp;Dmin = 23.1 mm <br> 2. Area S= 519.7 mm²',
      series_TAVI3: 'Annulus-Aorta Distance',
      clinical_TAVI3: 'Measure distance from brachiocephalic trunk to annulus<br>D= 97.0 mm',
      series_TAVI4: 'Aorta-Femoral VR',
      clinical_TAVI4: 'Showing the origins, courses and shapes of aorta &amp; its major branches',
      series_TAVI5: 'Lt-Iliac Measurement &amp; CR',
      clinical_TAVI5: 'Showing the diameters of left iliac &amp; femoral arteries, and evaluate their tortuosity &amp; calcification:<br> 1. L Common Iliac Artery: Dmax = 11.7 mm Dmin = 11.2 mm<br> 2. L Iliac Bif: Dmax = 9.3 mm Dmin = 6.2 mm <br> 3. Aorta to Lt-Iliac CR',
      series_TAVI6: 'Rt-Iliac Measurement &amp; CR',
      clinical_TAVI6: 'Showing the diameters of right iliac &amp; femoral arteries, and evaluate their tortuosity &amp; calcification:<br> 1. R Common Iliac Artery: Dmax = 11.6 mm Dmin = 11.0 mm<br> 2. R Iliac Bif: Dmax = 9.2 mm Dmin = 9.0 mm <br> 3. Aorta to Rt-Iliac CR'
    },
    KM: {
      series_KM1: 'Renal artery MIP',
      clinical_KM1: 'Showing courses and distributions of renal artery &amp; tumor arteries, &amp; their relationship with the mass.',
      series_KM2: 'Urinary MIP',
      clinical_KM2: 'Showing the collecting duct system &amp; its relationship with the mass.',
      series_KM3: 'Kidney mass &amp; Abd aorta VR',
      clinical_KM3: 'External view of the aorta and its major branches, showing the relationship between renal artery and the mass.',
      series_KM4: 'KUB VR',
      clinical_KM4: 'External view of renal calices, renal pelvis, ureter &amp; bladder, showing the collecting duct system &amp; its relationship with the mass.',
      series_KM5: 'Kidney mass &amp; IVC VR',
      clinical_KM5: 'External view of inferior vena cava &amp; renal vein, showing the relationship between rental vein, its branches and the kidney mass.',
      series_KM6: 'KUB, Aorta , IVC &amp; Bone VR',
      clinical_KM6: 'External view of aorta &amp; its branches, vena cava &amp; its branches, and urinary tract, and with transparent bones, showing their relationship with the kidney mass.',
      series_KM7: 'Measurements VR, MIP, MPR',
      clinical_KM7: '1. Maximum diameter &amp; vertical diameter of the kidney mass (mm)<br> 2. Volume of the mass (mm³)<br> 3. Shortest distance from the mass to the branch of renal artery (mm)<br> 4. Shortest distance from the mass to the branch of renal vein (mm)<br> 5. Shortest distance from the mass to the renal pelvis'
    },
    PT: {
      series_PT1: 'Pancreatic Axial',
      clinical_PT1: 'Axial view of the pancreas',
      series_PT2: 'Pancreatic Coronal',
      clinical_PT2: 'Coronal view of the pancreas',
      series_PT3: 'Abd Aorta MIP',
      clinical_PT3: 'Showing origins, courses, &amp; shapes of abdominal aorta and its major branches.',
      series_PT4: 'Abd Aorta VR',
      clinical_PT4: 'External View of abdominal aorta &amp; its major branches, showing their origins, courses &amp; shapes.',
      series_PT5: 'Pancreatic Mass VR',
      clinical_PT5: 'Showing stained pancreatic mass and its position inside the pancreas.',
      series_PT6: 'Pancreatic Mass &amp; Abd VR',
      clinical_PT6: 'Showing the relationship among pancreatic mass, pancreas, abdominal aorta and its major branches.',
      series_PT7: 'Pancreatic Mass &amp; Abd Bone VR',
      clinical_PT7: 'VR images of stained pancreatic mass, pancreas &amp; abdominal aorta &amp; its major branches are superimposed with images of whole abdomen, showing relationship among the mass, abdominal organs and boney structures.',
      series_PT8: 'Abd Aorta &amp; Major Branches MIP',
      clinical_PT8: 'Oblique MIP, showing courses of major abdominal branches:<br> Common Hepatic Artery<br>Superion Mesenteric Artery<br> Lt Renal Artery<br> Rt Renal Artery ',
      series_PT9: 'Measurements',
      clinical_PT9: 'Mass measurements on multiple planes:<br> Axial Dmax= 40.7 mm<br> Coronal Dmax= 37.2 mm<br> Sagittal Dmax= 35.8 mm<br> Volume：23.694 cm³'
    },
    AAA: {
      series_AAA1: 'Aorta CR',
      clinical_AAA1: 'Internal view of aorta, showing its overall condition &amp; the origins of its branches.',
      series_AAA2: 'Aorta MIP',
      clinical_AAA2: 'Displaying the origins, courses &amp; shapes of the aorta &amp; its branches.',
      series_AAA3: 'Aorta VR',
      clinical_AAA3: 'External view of aorta, showing its overall condition, and the courses and shapes of its branches.',
      series_AAA4: 'Aorta Bone VR',
      clinical_AAA4: 'VR images of aorta with semi-transparent bones &amp; stained aneurysm, showing the relationship among abdominal aorta, its major branches, &amp; bones.',
      series_AAA5: 'Aorta Abd VR',
      clinical_AAA5: 'Local view of AAA, showing its overall shape.',
      series_AAA6: 'Aneurysm Measurements',
      clinical_AAA6: 'Proximal aortic neck: 59.8 mm <br> Aortic neck angulations 98˚ 133.3°<br> Diameters of aneurysm ( @ max area) Dmax =42.2 mm Dmin =38.1 mm <br> Volume of aneurysm 125.769 cm³ ',
      series_AAA7: 'Diameters of Aorta',
      clinical_AAA7: 'Diameters of aorta within pararenal segment (mm):<br> Inf RA Level: Dmax = 20.2 Dmin = 17.9<br> Diameters of aorta 5, 10, 15mm below Inf RA (mm):<br> Dmax = 19.8 Dmin = 17.9<br> Dmax = 18.8 Dmin = 16.8<br> Dmax = 19.7 Dmin = 18.1<br> Diameter of aorta at aortic bifurcation:<br> Dmax = 44.2 Dmin = 39.3',
      series_AAA8: 'Diameter of Iliac &amp; Femoral Arteries',
      clinical_AAA8: 'Diameters of left/right common iliac artery at its bifurcation (mm):<br> L Iliac Bif: Dmax = 23.2 Dmin = 20.1<br> L Femoral: Dmax = 11.8 Dmin = 8.7<br> R Iliac Bif: Dmax = 26.4 Dmin =17.1<br> R Femoral: Dmax =13.6 Dmin =11.1',
      series_AAA9: 'Diameters of Abdominal Branches',
      clinical_AAA9: 'Diameters of major abdominal branches (mm) :<br> Celiac: Dmax = 9.2 Dmin = 8.6<br> SMA: Dmax = 11.3 Dmin =10.1 <br> L RA: Dmax = 9.0 Dmin = 8.7 <br> R RA: Dmax = 6.6 Dmin = 6.1',
      series_AAA10: 'Distances',
      clinical_AAA10: 'Useful distances (mm): <br> Inf RA--AAA 61.0, Inf RA—Aorta Bif 157.7, Aorta Bif –L Iliac Bif 21.5 Aorta Bif –R Iliac Bif 40.8.',
      series_AAA11: 'Orientation of Branch Vessels',
      clinical_AAA11: "Showing orientation of branch vessels for fenestrated device:<br>Celiac 1:00 O'Clock, SMA 12:00, R RA 9:00, L RA 3:30"
    }
  },
  about: {
    menuName: 'About'
  },
  media: {
    menuName: 'Media'
  },
  book: {
    menuName: 'Demo Request'
  },
  login: {
    menuName: 'Login'
  }
}

export default en
